import Action from '../action';

export const HISTORY_UPDATED = 'HISTORY_UPDATED';
export const HISTORY_ADDED = 'HISTORY_ADDED';
export const HISTORY_SELECTED = 'HISTORY_SELECTED';

export const selectHistory = history => Action(HISTORY_SELECTED, history);
export const historyAdded = history => Action(HISTORY_ADDED, history);
export const historyUpdated = history => Action(HISTORY_UPDATED, history);
